module.exports = __webpack_public_path__ + "img/qiwi.78e8574c.svg";